/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lines: NonNullable<unknown> }} Statement_Tree_Csv_Import_Invalid_RowsInputs */

const en_statement_tree_csv_import_invalid_rows = /** @type {(inputs: Statement_Tree_Csv_Import_Invalid_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing was imported. Check line(s) ${i?.lines}: use BS or PL, sign 1 or -1, fill Level1 and Level2, and do not repeat a RowId or a StatementType and Level path.`)
};

const nl_statement_tree_csv_import_invalid_rows = /** @type {(inputs: Statement_Tree_Csv_Import_Invalid_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Er is niets geïmporteerd. Controleer regel(s) ${i?.lines}: gebruik BS of PL, teken 1 of -1, vul Level1 en Level2 in en herhaal geen RowId of combinatie van StatementType en Levels.`)
};

/**
* | output |
* | --- |
* | "Nothing was imported. Check line(s) {lines}: use BS or PL, sign 1 or -1, fill Level1 and Level2, and do not repeat a RowId or a StatementType and Level path." |
*
* @param {Statement_Tree_Csv_Import_Invalid_RowsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_csv_import_invalid_rows = /** @type {((inputs: Statement_Tree_Csv_Import_Invalid_RowsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Csv_Import_Invalid_RowsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_csv_import_invalid_rows(inputs)
	return en_statement_tree_csv_import_invalid_rows(inputs)
});